import Button from '@components/Button';
import Image from '@components/Image';
import Row from '@components/Row';
import useProject from '@hooks/useProject';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import KakaoIcon from './ic_kakao.svg';
import RecentToolTip from '../RecentToolTip';
import useSignInWithKakao from './hooks/useSignInWithKakao';

const kakaoRedirectUri = import.meta.env.VITE_KAKAO_REDIRECT_URI;
const kakaoScriptUrl = import.meta.env.VITE_KAKAO_SCRIPT_URL;

interface Props {
    isLastLogin?: boolean;
}

function KakaoSignInButton({ isLastLogin }:Props) {
    const { t } = useTranslation('signIn');
    const { kakaoJsKey, handleKakaoLogin } = useSignInWithKakao();
    const project = useProject();
    if (kakaoJsKey && project?.serviceCountry === 'KR') {
        return (
            <Button fullWidth
                id='kakao-sign-in-button'
                unmanagedBackground='#FEE500'
                unmanagedColor='rgba(0, 0, 0, 0.85)'
                onClick={handleKakaoLogin}>
                <Row spacing={1.5}>
                    <Image src={KakaoIcon}
                        width={20}
                        height={20}
                        alt={t('kakao.alt')}/>
                    {t('kakao.button')}
                </Row>
                {isLastLogin && (
                    <RecentToolTip/>
                )}
            </Button>
        );
    }
    return (<Fragment/>);
}

export default KakaoSignInButton;
